module.exports = __webpack_public_path__ + "static/media/IMG_1245.a9d003d8.jpg";